// For Development
// export const SUCCESS_URL = 'http://127.0.0.1:3000/payment/success';
// export const FAILED_URL = 'http://127.0.0.1:3000/payment/failed';

// For Dev Remote
// export const SUCCESS_URL =
//   'https://emstelldemo.com/payment/success';
// export const FAILED_URL =
//   'https://emstelldemo.com/payment/failed';

// For Production server
export const SUCCESS_URL = 'https://courses.emstell.com/payment/success';
export const FAILED_URL = 'https://courses.emstell.com/payment/failed';

// For Production
// export const
